
  <div class="page-header">
    <div class="grid-container"> {{changeRequestVO?.id}} </div>
  </div>
  <div class="grid-container">
  <div class="header-helper" style="padding-bottom: 0 !important;">
    <p>A root zone change request for <b>{{changeRequestVO?.tldName | domainNameConverter}}</b> was submitted.
    </p>
    <p>As a proposed contact, IANA requests you to verify your
      information, review our privacy policy and confirm that you allow IANA to list the information below
      for {{changeRequestVO?.tldName | domainNameConverter}} in the IANA Root Zone database.</p>
    <p>This information was submitted by {{changeRequestVO?.requestMetadata?.submitterEmail}}
      on {{changeRequestVO?.requestMetadata?.dateOfSubmission | commonDate}}, and is the proposed
      contact detail that will be placed in our public database (updated
      items are <b>boldface</b>):
    </p>
  </div>

  <div class="content content-with-elevation">
    <summary-of-changes [newDelegation]="false" [changeRequest]="changeRequestVO"
                        [showTicketNumbers]="false"></summary-of-changes>
  </div>

  <p style="margin-top: 16px;">If the information above is correct, and you have reviewed our Privacy Policy and Terms
    of Service, do you
    consent to be a contact for {{changeRequestVO?.tldName | domainNameConverter}}. and listed in the
    IANA Root Zone Database?
  </p>
  <div class="content-header">
    Actions
  </div>
  <div class="content content-with-elevation" style="margin-top: 16px">
    <form [formGroup]="changeRequestAcceptRejectForm"
          novalidate (submit)="onSubmit(target)">
      <div class="requestDetailsContent">
        <p>Enter your response for this change request. Your response and reason will be recorded.</p>

        <div class="grid-x">
          <fieldset>
            <input type="radio" formControlName="changeRequestAction" value="APPROVE" id="approve" required><label
            for="approve">I consent.</label><br/>
            <input type="radio" formControlName="changeRequestAction" value="REJECT" id="reject" required><label
            for="reject">I do not consent.</label>
          </fieldset>
        </div>
        <div class="grid-x" *ngIf="this.changeRequestAcceptRejectForm.value.changeRequestAction === 'REJECT'">
          <div class="cell medium-12 large-12 small-12"><textarea formControlName="comment"
                                                                  placeholder="Please provide an explanation for rejecting here."
                                                                  maxlength="256"
                                                                  class="input-group-custom"
                                                                  style="width: 100%"></textarea>
            <lib-whitelist-character-error [whitelistFormControl]="comment"></lib-whitelist-character-error>
          </div>
        </div>
      </div>
      <div class="save-cancel-button-group" style="margin-bottom: 16px;">
        <button class="iana-button" type="submit" [disabled]="isFormInValid()">Submit
        </button>
      </div>
    </form>
  </div>
    <div id="success" class="finalize-request" *ngIf="successMessage">
      {{successMessage}}
    </div>
    <common-alerts *ngIf="errorMessage" [error]="error"></common-alerts>
    <div id="error" class="finalize-request" *ngIf="errorMessage">
      {{errorMessage}}
    </div>
    <div #target></div>
  </div>

